const createNode = <T extends keyof React.JSX.IntrinsicElements = 'div'>({
    id,
    nodeClassName,
    tagName,
    attributes = {},
    data,
}: {
    id: string;
    nodeClassName?: string;
    tagName: T | string;
    attributes?: React.HTMLProps<T>;
    data?: any;
}) => {
    return {
        type: 'element',
        tagName,
        children: [],
        properties: {
            ...attributes,
            id,
            className: nodeClassName,
        },
        data,
    };
};

export default createNode;
